import { getApiInstance } from '../../../helpers/api.helpers';
/**
 * Lists study notification templates for a site the caller can access
 * (`GET /v2/routes/c_sites/:siteId/c_notification_templates`, AXONCONFIG-5254).
 */
export const fetchNotificationTemplates = async ({ environment, siteId, locale, }) => {
    const api = getApiInstance(environment, locale);
    const resp = await api.get(`/v2/routes/c_sites/${siteId}/c_notification_templates`);
    const body = (resp?.data ?? {});
    return Array.isArray(body.data) ? body.data : [];
};
